import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { getClientsPageTokens } from '../getClientsPageTokens';
import { CLIENTS_PAGE_LAYOUT_SIZES } from '../clientsTokens';

export interface ClientsPageHeaderProps {
  subtitle: string;
  title?: string;
}

export function ClientsPageHeader({
  subtitle,
  title = 'Clients',
}: ClientsPageHeaderProps): JSX.Element {
  const theme = useTheme();
  const tokens = getClientsPageTokens(theme);

  return (
    <>
      <Typography
        component="h1"
        sx={{
          fontSize: '30px',
          fontWeight: 500,
          lineHeight: '36px',
          letterSpacing: '0.3955px',
          color: tokens.pageHeadingColor,
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          mt: `${CLIENTS_PAGE_LAYOUT_SIZES.headingToSubtitleGap}px`,
          fontSize: '16px',
          fontWeight: 400,
          lineHeight: '24px',
          letterSpacing: '-0.3125px',
          color: tokens.pageSubtitleColor,
        }}
      >
        {subtitle}
      </Typography>
    </>
  );
}
